export const initialState = {
  data: { total_devices: 0, total_locations: 0, locations_piechart: [], problems_count: 0 },
};
